import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/duanwu-festival/2025/Index.vue')
const Winners = () => import('../activity/duanwu-festival/2025/winners/Index.vue')
const ZongziFactory = () => import('../activity/duanwu-festival/2025/ZongziFactory.vue')
const LotteryRewards = () => import('../activity/duanwu-festival/2025/LotteryRewards.vue')
const ZongziMaterialRecords = () => import('../activity/duanwu-festival/2025/ZongziMaterialRecords.vue')

const DragonHome = () => import('../activity/duanwu-festival/2025/dragon-boat/Index.vue')
const Kitchen = () => import('../activity/duanwu-festival/2025/KitchenStealMaterialPage.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025',
  name: 'activity_duanwu_festival_2025',
  component: Index,
  redirect: '/activity/duanwu-festival/2025/winners',
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '端午节活动',
  },
}

export const winnersRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025/winners',
  name: 'activity_duanwu_festival_2025_winners',
  component: Winners,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '端午节活动',
  },
}

export const zongziFactoryRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025/zongzi-factory',
  name: 'activity_duanwu_festival_2025_zongzi_factory',
  component: ZongziFactory,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '小队粽子制作',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025/lottery-rewards',
  name: 'activity_duanwu_festival_2025_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const zongziMaterialRecordsRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025/zongzi-material-records',
  name: 'activity_duanwu_festival_2025_zongzi_material_records',
  component: ZongziMaterialRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '战队食材明细',
  },
}

export const dragonHomeRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025/dragon',
  name: 'activity_duanwu_festival_2025_dragon',
  component: DragonHome,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '端午节龙舟',
  },
}

export const kitchenStealMaterialRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2025/kitchen',
  name: 'activity_duanwu_festival_2025_kitchen',
  component: Kitchen,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '厨房',
  },
}

export default [
  indexRoute,
  winnersRoute,
  zongziFactoryRoute,
  lotteryRewardsRoute,
  zongziMaterialRecordsRoute,
  dragonHomeRoute,
  kitchenStealMaterialRoute,
]
